import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { RouteHeading, RouteUiDataService } from './route-ui-data';
import { SEOService } from './seo.service';

export const BRAND = 'Russ Rodgers';
export const DEFAULT_TITLE = `One-on-One Online Bass Guitar Lessons | ${BRAND}`;
export const BRAND_SUFFIX = ` | ${BRAND}`;

@Injectable({
  providedIn: 'root',
})
export class RouteTitleStrategy extends TitleStrategy {
  title = inject(Title);

  getTitle(snapshot: RouterStateSnapshot): string {
    const title = this.buildTitle(snapshot);
    if (title !== undefined) {
      return `${title}${BRAND_SUFFIX}`;
    } else {
      return DEFAULT_TITLE;
    }
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(this.getTitle(snapshot));
  }
}

/**
 * Facade for imperative per-page title changes (e.g. dynamic blog routes
 * whose title depends on a route param resolved after navigation).
 *
 * Keeps the document `<title>`, the SEO service's mirrored `<meta>`/OG/
 * Twitter title tags, and the page's `<h1>` (via the runtime heading
 * override) all in lockstep from a single call site.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private title = inject(Title);
  private seo = inject(SEOService);
  private routeUiData = inject(RouteUiDataService);

  setPageTitle(fullTitle: string, heading?: RouteHeading): void {
    this.title.setTitle(fullTitle);
    this.seo.setRouteTitle(fullTitle);
    if (heading) {
      this.routeUiData.setHeadingOverride(heading);
    }
  }
}
